import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const selectCoverDetails = (state: RootState) => state.coverDetails;

export const selectIsValidBreakdown = createSelector(
  selectCoverDetails,
  ({ breakdown }) =>
    breakdown?.numberOfItems && breakdown?.sumInsured && breakdown?.deteriorationOfStock
);
